<template>
  <div class="privacy-section mb-5">
    <h2 v-if="title">{{ title }}</h2>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'PrivacySection',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.privacy-section {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
}

.privacy-section h2 {
  color: #2a5298;
  margin-bottom: 1.5rem;
  font-size: 2rem;
  font-weight: 700;
  border-bottom: 3px solid #667eea;
  padding-bottom: 0.5rem;
}

.privacy-section p {
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 1rem;
  color: #333;
  text-align: justify;
}

.privacy-section ul {
  font-size: 1.1rem;
  line-height: 1.8;
  padding-left: 2rem;
  margin-bottom: 1rem;
}

.privacy-section li {
  margin-bottom: 0.75rem;
  color: #555;
}

.privacy-section li strong {
  color: #2a5298;
}

.privacy-section a {
  color: #667eea;
  text-decoration: none;
  font-weight: 500;
}

.privacy-section a:hover {
  color: #2a5298;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .privacy-section {
    padding: 1.5rem;
  }

  .privacy-section h2 {
    font-size: 1.6rem;
  }

  .privacy-section p,
  .privacy-section ul {
    font-size: 1rem;
  }
}
</style>

